import React from 'react';

export default function BotStatus({ status, wsConnected, compact }) {
  const isRunning = status?.running;

  if (compact) {
    return (
      <div className="flex items-center gap-2" data-testid="bot-status">
        <div className={`w-2 h-2 rounded-full ${isRunning ? 'bg-tf-success animate-pulse-dot' : 'bg-tf-danger'}`} data-testid="bot-status-dot" />
        {wsConnected !== undefined && (
          <div className={`w-1.5 h-1.5 rounded-full ${wsConnected ? 'bg-tf-accent' : 'bg-tf-text-3'}`} />
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 sm:gap-4" data-testid="bot-status">
      <div className="flex items-center gap-2">
        <div className={`w-2 h-2 rounded-full ${isRunning ? 'bg-tf-success animate-pulse-dot' : 'bg-tf-danger'}`} data-testid="bot-status-dot" />
        <span className="font-mono text-[9px] tracking-[0.15em] uppercase text-tf-text-2 hidden sm:inline">
          {isRunning ? 'Bot Online' : 'Bot Offline'}
        </span>
      </div>
      <span className="font-mono text-[10px] text-tf-accent font-bold hidden md:inline" data-testid="bot-name">@TrustframeBot</span>
      {wsConnected !== undefined && (
        <div className="flex items-center gap-1.5" data-testid="ws-status">
          <div className={`w-1.5 h-1.5 rounded-full ${wsConnected ? 'bg-tf-accent' : 'bg-tf-text-3'}`} />
          <span className="font-mono text-[8px] tracking-[0.15em] uppercase text-tf-text-2 hidden sm:inline">{wsConnected ? 'Live' : 'Polling'}</span>
        </div>
      )}
    </div>
  );
}
